import React from 'react'

const ValidationErrors = ({ errors }) => {
  return <ul>{errors?.map((error, i) => <li key={i}>{error}</li>)}</ul>
}
export default ValidationErrors
